import React from 'react';
import SingleContentItem from './SingleContentItem';

type PlanOverviewWebProps = {
	plan: any;
	onOpenPlan?: () => void;
};

const PlanOverview: React.FC<PlanOverviewWebProps> = ({ plan }) => {
	if (!plan) return null;

	return (
		<div className='mt-6 flex w-full flex-col gap-6'>
			<div className='flex items-center justify-between px-1'>
				<h3 className='m-0 text-xl font-bold text-[#413F5E]'>User's Plan</h3>
			</div>

			<div className='flex flex-col gap-6'>
				{plan.contentItems?.map((section: any, idx: number) => (
					<div key={idx} className='flex flex-col gap-3'>
						{section.title && (
							<div className='flex justify-between'>
								<span className='text-xs font-semibold uppercase text-[#9392AD]'>{section.title}</span>
							</div>
						)}

						<div className='flex flex-col gap-2.5'>
							{section.items.map((item: any, j: number) => (
								<SingleContentItem key={j} contentItem={item} showProgress={j < 3} viewOnly />
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default PlanOverview;
